
import React, { Component } from 'react';
import { logout } from '../../../actions/AppActions';
import { connect } from 'react-redux';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';

// solicitacoes
import SeparacoesPendentes from './SeparacoesAbertas';
import SeparacoesFinalizadas from './SeparacoesFinalizadas';
import Filter from '../../../Auxiliar/Filter';

const SelecionarJsSeparacao = () => {
    const [search, setSearch] = React.useState(false)
    const [dateOf, setDateOf] = React.useState('')
    const [dateFor, setDateFor] = React.useState('')
    const [options, setOptions] = React.useState({
        separacaoPendente: { value: true, label: 'Separacões Pendentes', checked: true },
        separacaoFinalizada: { value: false, label: 'Separações Finalizadas', checked: false },
    })

    return (
        <div className="card">
            <div className="card-body" id="card">
                <div className="d-flex align-items-start">
                    <h4 className="mt-0 header-title" style={{ fontSize: '1.5rem', color: 'black' }}>Separações</h4>
                    <Filter setDateOf={setDateOf} setDateFor={setDateFor} options={options} setOptions={setOptions} setSearch={setSearch} />
                </div>
                <div>
                    <p style={{ fontSize: '1rem', color: 'black' }}>Aqui são listados as separações do sistema</p>
                </div>
                <div className="row">
                    {options.separacaoFinalizada.value &&
                        <SeparacoesFinalizadas dateOf={dateOf} dateFor={dateFor} search={search} setSearch={setSearch} />}
                    {options.separacaoPendente.value &&
                        <SeparacoesPendentes dateOf={dateOf} dateFor={dateFor} search={search} setSearch={setSearch} />}
                </div>
            </div>
        </div>
    )
}

export default SelecionarJsSeparacao


